import { render, staticRenderFns } from "./qus-foot.vue?vue&type=template&id=5de57512&"
import script from "./qus-foot.vue?vue&type=script&lang=js&"
export * from "./qus-foot.vue?vue&type=script&lang=js&"
import style0 from "./qus-foot.vue?vue&type=style&index=0&id=5de57512&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports